export const imageCache = {
    __cache: {},
    read(src) {
      if (!src) {
        return;
      }
  
      if (!this.__cache[src]) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            this.__cache[src] = img;
            resolve(this.__cache[src]);
          };
          img.src = src;
          setTimeout(() => resolve({}), 7000);
        }).then((img) => {
          this.__cache[src] = img;

          return Promise.resolve(src);
        });
      } else {
        return Promise.resolve(src);
      }
    },
    clearImg(src) {
      delete this.__cache[src];
    },
    clear() {
        this.__cache = {};
    }
  };
  